import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ResetPasswordService {
  private loadingSubject = new BehaviorSubject<boolean>(false);
  readonly loading$ = this.loadingSubject.asObservable();

  constructor(private httpClient: HttpClient) {}

  requestResetToken(email: string, captchaResponse: string, username?: string): Observable<void> {
    this.loadingSubject.next(true);
    return this.httpClient
      .post<void>(`/accounts/password/token/request`, {
        emailAddress: email,
        captchaResponse,
        ...(username ? { username } : {}),
      })
      .pipe(finalize(() => this.loadingSubject.next(false)));
  }

  resetPasswordValue(password: string, token: string): Observable<void> {
    this.loadingSubject.next(true);
    return this.httpClient.post<void>(`/accounts/password/reset`, { newPassword: password, token: token })
      .pipe(finalize(() => this.loadingSubject.next(false)));
  }
}
